'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dGrouping$002dName$0024$0024anon$002439 from "./presto.types$-Grouping-Name$$anon$39.js";
import * as $j_presto$002etypes$0024$002dGrouping$002dName$0024$0024anon$002440 from "./presto.types$-Grouping-Name$$anon$40.js";
var $p;
/** @constructor */
function $c_Lpresto_types$GroupingName$() {
  this.c8q = null;
  this.c8r = false;
  this.c8o = null;
  this.c8p = false;
  this.c8u = null;
  this.c8v = false;
  this.c8s = null;
  this.c8t = false;
  this.c8w = null;
  this.c8x = false;
}
export { $c_Lpresto_types$GroupingName$ as $c_Lpresto_types$GroupingName$ };
$p = $c_Lpresto_types$GroupingName$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$GroupingName$;
/** @constructor */
function $h_Lpresto_types$GroupingName$() {
}
export { $h_Lpresto_types$GroupingName$ as $h_Lpresto_types$GroupingName$ };
$h_Lpresto_types$GroupingName$.prototype = $p;
$p.csT = (function() {
  if ((!this.c8r)) {
    this.c8q = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.c8r = true;
  }
  return this.c8q;
});
$p.nO = (function() {
  if ((!this.c8p)) {
    this.c8o = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a9;
    this.c8p = true;
  }
  return this.c8o;
});
$p.ct8 = (function() {
  if ((!this.c8v)) {
    this.c8u = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((x) => x)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.c8v = true;
  }
  return this.c8u;
});
$p.cJA = (function() {
  if ((!this.c8t)) {
    this.c8s = new $j_presto$002etypes$0024$002dGrouping$002dName$0024$0024anon$002439.$c_Lpresto_types$GroupingName$$anon$39(this);
    this.c8t = true;
  }
  return this.c8s;
});
$p.cK5 = (function() {
  if ((!this.c8x)) {
    this.c8w = new $j_presto$002etypes$0024$002dGrouping$002dName$0024$0024anon$002440.$c_Lpresto_types$GroupingName$$anon$40(this);
    this.c8x = true;
  }
  return this.c8w;
});
var $d_Lpresto_types$GroupingName$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$GroupingName$, "presto.types$GroupingName$", ({
  a0x: 1,
  D: 1
}));
export { $d_Lpresto_types$GroupingName$ as $d_Lpresto_types$GroupingName$ };
var $n_Lpresto_types$GroupingName$;
function $m_Lpresto_types$GroupingName$() {
  if ((!$n_Lpresto_types$GroupingName$)) {
    $n_Lpresto_types$GroupingName$ = new $c_Lpresto_types$GroupingName$();
  }
  return $n_Lpresto_types$GroupingName$;
}
export { $m_Lpresto_types$GroupingName$ as $m_Lpresto_types$GroupingName$ };
//# sourceMappingURL=presto.types$-Grouping-Name$.js.map
